var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInsta2 = function SvgInsta2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.333 1.333a3.344 3.344 0 0 1 3.334 3.334v6.666a3.344 3.344 0 0 1-3.334 3.334H4.667a3.344 3.344 0 0 1-3.334-3.334V4.667a3.344 3.344 0 0 1 3.334-3.334zm0-1.333H4.667A4.68 4.68 0 0 0 0 4.667v6.666A4.68 4.68 0 0 0 4.667 16h6.666A4.68 4.68 0 0 0 16 11.333V4.667A4.68 4.68 0 0 0 11.333 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.336 4.672a1.003 1.003 0 1 1 0-2.005 1.003 1.003 0 0 1 0 2.005M8 5.332a2.667 2.667 0 1 1 0 5.333 2.667 2.667 0 0 1 0-5.333m0-1.333a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })));
};
export default SvgInsta2;